import GridTile from "./GridTile";
import { memo } from "react";
import "../../scss/Grid.scss";
import { IGridData } from "../../types";

const GridTileView = ({
  data,
  keyWord,
}: {
  data: IGridData[];
  keyWord: string;
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-8 mb-8 w-full max-w-6xl mx-auto">
      {data
        ?.filter((d) => d.is_open)
        .map((d) => (
          <GridTile key={d.id} data={d} keyWord={keyWord} />
        ))}
    </div>
  );
};
export default memo(GridTileView);
